import {
  faBellConcierge,
  faBuilding,
  faCheck,
  faCheckDouble,
  faGem,
  faUmbrellaBeach,
  faWater,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cloneElement } from "react";

const featuresMapIcon: Record<string, JSX.Element> = {
  "select service": <FontAwesomeIcon icon={faCheck} />,
  "full service": <FontAwesomeIcon icon={faBellConcierge} />,
  luxury: <FontAwesomeIcon icon={faGem} />,
  resort: <FontAwesomeIcon icon={faUmbrellaBeach} />,
  "enhanced select service": <FontAwesomeIcon icon={faCheckDouble} />,
  downtown: <FontAwesomeIcon icon={faBuilding} />,
  waterfront: <FontAwesomeIcon icon={faWater} />,
};

interface FeaturesIconProps {
  title: string;
  color: string;
  fontSize: string;
  width: string;
}

export default function FeaturesIcons(props: FeaturesIconProps) {
  const { title, ...rest } = props;
  const name = title.toLowerCase();
  const featureIcon: JSX.Element | null = featuresMapIcon[name] || null;

  return featureIcon ? cloneElement(featureIcon, { ...rest }) : null;
}
